import { useState } from "react";
import {
  Box,
  Container,
  TextField,
  InputAdornment,
  IconButton,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  MenuItem,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import TuneIcon from "@mui/icons-material/Tune";

export default function EventSearchBar() {
  const [open, setOpen] = useState(false);
  const [filters, setFilters] = useState({
    query: "",
    city: "",
    state: "",
    type: "",
    artist: "",
  });

  return (
    <>
      {/* SEARCH BAR */}
      <Box
        sx={{
          py: { xs: 1, md: 3 },
          background:
            "linear-gradient(180deg, rgba(10,25,47,0) 0%, rgba(10,25,47,0.35) 100%)",
        }}
      >
        <Container maxWidth="lg">
          <Box
            onClick={() => setOpen(true)}
            sx={{
              mx: "auto",
              maxWidth: 820,
              backdropFilter: "blur(14px)",
              bgcolor: "rgba(255,255,255,0.06)",
              border: "1px solid rgba(255,255,255,0.12)",
              borderRadius: 1,
              px: { xs: 2, md: 3 },
              py: 1.4,
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              cursor: "pointer",
              transition: "all .25s ease",
              "&:hover": {
                bgcolor: "rgba(255,255,255,0.1)",
                borderColor: "rgba(255,255,255,0.2)",
              },
            }}
          >
            <SearchIcon sx={{ color: "rgba(255,255,255,0.7)" }} />

            <Typography
              sx={{
                flex: 1,
                color: "rgba(255,255,255,0.85)",
                fontSize: { xs: 14, md: 15 },
              }}
            >
              Buscar eventos, artistas ou cidades…
            </Typography>

            <IconButton
              sx={{
                bgcolor: "rgba(0,255,163,0.15)",
                color: "#00FFA3",
                "&:hover": {
                  bgcolor: "rgba(0,255,163,0.25)",
                },
              }}
            >
              <TuneIcon />
            </IconButton>
          </Box>
        </Container>
      </Box>

      {/* MODAL DE FILTROS */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
        sx={{
          backgroundColor: "rgba(0,0,0,0.0)",
          backdropFilter: "blur(4px)",
        }}
        PaperProps={{
          sx: {
            borderRadius: 1,
            bgcolor: "#0B0F17",
            border: "1px solid rgba(255,255,255,0.12)",
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 900 }}>Buscar eventos</DialogTitle>

        <DialogContent dividers sx={{ pt: 0 }}>
          <Stack spacing={3} mt={3} mb={2}>
            <TextField
              label="Nome do evento"
              fullWidth
              value={filters.query}
              onChange={(e) =>
                setFilters({ ...filters, query: e.target.value })
              }
            />

            <TextField
              label="Artista / atração"
              fullWidth
              value={filters.artist}
              onChange={(e) =>
                setFilters({ ...filters, artist: e.target.value })
              }
            />

            <Stack direction="row" spacing={2}>
              <TextField
                label="Cidade"
                fullWidth
                value={filters.city}
                onChange={(e) =>
                  setFilters({ ...filters, city: e.target.value })
                }
              />
              <TextField
                label="Estado"
                fullWidth
                value={filters.state}
                onChange={(e) =>
                  setFilters({ ...filters, state: e.target.value })
                }
              />
            </Stack>

            <TextField
              label="Tipo de evento"
              select
              fullWidth
              value={filters.type}
              onChange={(e) => setFilters({ ...filters, type: e.target.value })}
            >
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="show">Show</MenuItem>
              <MenuItem value="festival">Festival</MenuItem>
              <MenuItem value="balada">Balada</MenuItem>
              <MenuItem value="teatro">Teatro</MenuItem>
              <MenuItem value="standup">Stand-up</MenuItem>
              <MenuItem value="corporativo">Corporativo</MenuItem>
            </TextField>
          </Stack>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button
            onClick={() => setOpen(false)}
            sx={{ color: "rgba(255,255,255,0.7)", borderRadius: 1 }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            sx={{
              bgcolor: "#00FFA3",
              color: "#000",
              fontWeight: 900,
              borderRadius: 1,
              px: 4,
              "&:hover": { bgcolor: "#00e695" },
            }}
            onClick={() => {
              setOpen(false);
              console.log("Filtros aplicados:", filters);
            }}
          >
            Buscar eventos
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
